import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServicesHero from "./sections/ServicesHero";
import ServiceOfferings from "./sections/ServiceOfferings";
import ContactInquiry from "./sections/ContactInquiry";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServicesHero />
      <ServiceOfferings />
      <ContactInquiry />
      <Footer />
    </div>;
}